import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  signal,
  WritableSignal,
} from '@angular/core';
import { AnimateModule } from '../animate/animate.module';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, AnimateModule],
})
export class PaginatorComponent implements OnInit {
  public _totalPages: WritableSignal<number> = signal(1);
  get totalPages(): number {
    return this._totalPages();
  }
  @Input() set totalPages(value: number) {
    this._totalPages.set(value);
    this.updateValues();
  }

  @Output()
  public readonly onPageChange = new EventEmitter<{
    page: number;
  }>();

  public activePage: WritableSignal<number> = signal(1);
  public prevActivePage: WritableSignal<number | null> = signal(null);
  public pages: WritableSignal<number[]> = signal([1]);
  public pagesToDisplay: WritableSignal<number[]> = signal([1]);

  public ngOnInit(): void {
    this.updateValues();
  }

  public updateValues(): void {
    const allPagesArray = [];
    for (let i = 1; i < this.totalPages + 1; i++) {
      allPagesArray.push(i);
    }
    this.pages.set(allPagesArray);
    this.setPagesToDisplay();
  }

  public ngOnDestroy(): void {
    this.pages.set([1]);
    this.pagesToDisplay.set([1]);
    this.activePage.set(1);
  }

  public setPagesToDisplay(): void {
    if (this.activePage() <= 4) {
      const pagesToDisplayArray = [];
      for (let i = 1; i <= Math.min(5, this.pages().length); i++) {
        pagesToDisplayArray.push(i);
      }
      this.pagesToDisplay.set(pagesToDisplayArray);
    } else {
      const pagesToDisplayArray = [];

      for (
        let i = this.activePage() - 2;
        i <= Math.min(this.activePage() + 2, this.pages()[this.pages().length - 1]);
        i++
      ) {
        pagesToDisplayArray.push(i);
      }
      this.pagesToDisplay.set(pagesToDisplayArray);
    }

    if (this.activePage() !== this.prevActivePage()) {
      this.onPageChange.emit({ page: this.activePage() });
    }
    this.prevActivePage.set(this.activePage());
  }

  public goNext(): void {
    if (this.activePage() === this.pages()[this.pages().length - 1]) {
      return;
    } else {
      this.activePage.set(this.activePage() + 1);
      this.setPagesToDisplay();
    }
  }

  public goToStart(): void {
    this.activePage.set(1);
    this.setPagesToDisplay();
  }

  public goPrev(): void {
    if (this.activePage() === 1) {
      return;
    } else {
      this.activePage.set(this.activePage() - 1);
      this.setPagesToDisplay();
    }
  }

  public goToEnd(): void {
    this.activePage.set(this.pages().length);
    this.setPagesToDisplay();
  }
}
